import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { ContactModel } from '../model/contact.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
    providedIn: 'root'
})
export class ContactService extends BaseFucntionsService<ContactModel> {

    constructor(apiClient: ApiClientService) {
        super(ApplicationRoutes.Contact.Contacts, apiClient);
    }

    GetContactSettings() {
        return this.apiClient.get(`${ApplicationRoutes.Contact.Settings}`);
    }


}
